import styled from 'styled-components';
import { ThemeColours } from '../../../common/styles/ThemeColours';
import { FONT_STACK, FontSize } from '../../../common/styles/constants';
import { onMobile } from '../../../common/styles/onMobile';

export const SearchCardBody = styled.p`
  ${FONT_STACK};
  color: ${ThemeColours.mono600};
  font-size: ${FontSize.SMALL};
  text-align: left;
`;

export const CardChop = styled.div`
  display: flex;
  flex-direcion: row;
  justify-content: space-between;

  ${onMobile} {
    margin-top: 8px;
  }
`;

export const LeftCardChop = styled.div`
  min-width: 0px;
`;
